import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from './ui/badge';

const ProductCard = ({ product }) => {
  return (
    <Link 
      to={`/product/${product.id}`}
      className="group block bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
    >
      {/* Image Container */}
      <div className="relative aspect-square overflow-hidden bg-gray-100">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {/* Category Badge */}
        <Badge 
          className="absolute top-3 left-3 bg-gray-800/90 hover:bg-gray-800 text-white text-xs font-medium px-3 py-1"
        >
          {product.category}
        </Badge>
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className="font-serif text-lg font-semibold text-gray-900 mb-2 group-hover:text-amber-600 transition-colors">
          {product.name}
        </h3>
        <p className="text-gray-500 text-sm leading-relaxed mb-4 line-clamp-2">
          {product.description}
        </p>
        <div className="flex items-center justify-between">
          <span className="font-serif text-xl font-bold text-amber-600">
            ${product.price.toFixed(2)}
          </span>
          {product.customizable && (
            <span className="text-xs text-gray-500 border border-gray-200 px-2 py-1 rounded">
              Customizable
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
